export default __webpack_public_path__ + "static/media/softwareMode.a7055245.svg";